import React from 'react'
import { Alert, List } from '@mantine/core'

interface Props {
  errors: { response?: { data?: { errors?: string[] } } } | string[] | null;
}

export default function ValidationErrors ({ errors }: Props) {
  const items = Array.isArray(errors)
    ? errors
    : errors?.response?.data?.errors

  if (!items?.length) return null

  return (
    <Alert color="red" title="Validation failed">
      <List size="sm" spacing={4}>
        {items.map((err, i) => (
          <List.Item key={i}>{err}</List.Item>
        ))}
      </List>
    </Alert>
  )
}
